export const REVISION_NOTIFICATION_TYPE = 'revision';

const REVISION_TITLE_PREFIXES = [
  'Labour Requirement Revised',
  'Labour Actual Revised',
];

interface RevisionSource {
  type?: string | null;
  title?: string | null;
}

export function isRevisionNotification(n: RevisionSource): boolean {
  const type = (n.type ?? '').trim().toLowerCase();
  if (type === REVISION_NOTIFICATION_TYPE || type.endsWith('_revision')) return true;

  const title = (n.title ?? '').trim();
  return REVISION_TITLE_PREFIXES.some((prefix) => title.startsWith(prefix));
}
